/* sucrase/dist/esm/parser/traverser/statement.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.parseTopLevel = parseTopLevel;
    exports.parseStatement = parseStatement;
    exports.parseDecorators = parseDecorators;
    exports.baseParseMaybeDecoratorArguments = baseParseMaybeDecoratorArguments;
    exports.parseVarStatement = parseVarStatement;
    exports.parseBlock = parseBlock;
    exports.parseBlockBody = parseBlockBody;
    exports.parseFunction = parseFunction;
    exports.parseFunctionParams = parseFunctionParams;
    exports.parseClass = parseClass;
    exports.parseClassPropertyName = parseClassPropertyName;
    exports.parsePostMemberNameModifiers = parsePostMemberNameModifiers;
    exports.parseClassProperty = parseClassProperty;
    exports.parseExport = parseExport;
    exports.parseExportFrom = parseExportFrom;
    exports.baseParseExportStar = baseParseExportStar;
    exports.parseExportSpecifiers = parseExportSpecifiers;
    exports.parseImport = parseImport;
    const index_1 = require("7a45c9fdec") /* ../index */;
    const flow_1 = require("9b8d43cd0a") /* ../plugins/flow */;
    const typescript_1 = require("6a970c22b9") /* ../plugins/typescript */;
    const tokenizer_1 = require("bfb18d0576") /* ../tokenizer */;
    const keywords_1 = require("99ff836c64") /* ../tokenizer/keywords */;
    const state_1 = require("eda46439d5") /* ../tokenizer/state */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const base_1 = require("540718e523") /* ./base */;
    const expression_1 = require("8178e7c3c8") /* ./expression */;
    const lval_1 = require("4cefc59e67") /* ./lval */;
    const util_1 = require("bc94bbadc1") /* ./util */;
    function parseTopLevel() {
        parseBlockBody(types_1.TokenType.eof);
        base_1.state.scopes.push(new state_1.Scope(0, base_1.state.tokens.length, true));
        if (base_1.state.scopeDepth !== 0) {
            throw new Error(`Invalid scope depth at end of file: ${base_1.state.scopeDepth}`);
        }
        return new index_1.File(base_1.state.tokens, base_1.state.scopes);
    }
    // Parse a single statement.
    //
    // If expecting a statement and finding a slash operator, parse a
    // regular expression literal. This is to handle cases like
    // `if (foo) /blah/.exec(foo)`, where looking at the previous token
    // does not help.
    function parseStatement(declaration) {
        if (base_1.isFlowEnabled) {
            if ((0, flow_1.flowTryParseStatement)()) {
                return;
            }
        }
        if ((0, tokenizer_1.match)(types_1.TokenType.at)) {
            parseDecorators();
        }
        parseStatementContent(declaration);
    }
    function parseStatementContent(declaration) {
        if (base_1.isTypeScriptEnabled) {
            if ((0, typescript_1.tsTryParseStatementContent)()) {
                return;
            }
        }
        const starttype = base_1.state.type;
        // Most types of statements are recognized by the keyword they
        // start with. Many are trivial to parse, some require a bit of
        // complexity.
        switch (starttype) {
            case types_1.TokenType._break:
            case types_1.TokenType._continue:
                parseBreakContinueStatement();
                return;
            case types_1.TokenType._debugger:
                parseDebuggerStatement();
                return;
            case types_1.TokenType._do:
                parseDoStatement();
                return;
            case types_1.TokenType._for:
                parseForStatement();
                return;
            case types_1.TokenType._function:
                if ((0, tokenizer_1.lookaheadType)() === types_1.TokenType.dot)
                    break;
                if (!declaration)
                    (0, util_1.unexpected)();
                parseFunctionStatement();
                return;
            case types_1.TokenType._class:
                if (!declaration)
                    (0, util_1.unexpected)();
                parseClass(true);
                return;
            case types_1.TokenType._if:
                parseIfStatement();
                return;
            case types_1.TokenType._return:
                parseReturnStatement();
                return;
            case types_1.TokenType._switch:
                parseSwitchStatement();
                return;
            case types_1.TokenType._throw:
                parseThrowStatement();
                return;
            case types_1.TokenType._try:
                parseTryStatement();
                return;
            case types_1.TokenType._let:
            case types_1.TokenType._const:
                if (!declaration)
                    (0, util_1.unexpected)(); // NOTE: falls through to _var
            case types_1.TokenType._var:
                parseVarStatement(starttype !== types_1.TokenType._var);
                return;
            case types_1.TokenType._while:
                parseWhileStatement();
                return;
            case types_1.TokenType.braceL:
                parseBlock();
                return;
            case types_1.TokenType.semi:
                parseEmptyStatement();
                return;
            case types_1.TokenType._export:
            case types_1.TokenType._import: {
                const nextType = (0, tokenizer_1.lookaheadType)();
                if (nextType === types_1.TokenType.parenL || nextType === types_1.TokenType.dot) {
                    break;
                }
                (0, tokenizer_1.next)();
                if (starttype === types_1.TokenType._import) {
                    parseImport();
                }
                else {
                    parseExport();
                }
                return;
            }
            case types_1.TokenType.name:
                if (base_1.state.contextualKeyword === keywords_1.ContextualKeyword._async) {
                    const functionStart = base_1.state.start;
                    // peek ahead and see if next token is a function
                    const snapshot = base_1.state.snapshot();
                    (0, tokenizer_1.next)();
                    if ((0, tokenizer_1.match)(types_1.TokenType._function) && !(0, util_1.canInsertSemicolon)()) {
                        (0, util_1.expect)(types_1.TokenType._function);
                        parseFunction(functionStart, true);
                        return;
                    }
                    else {
                        base_1.state.restoreFromSnapshot(snapshot);
                    }
                }
                else if (base_1.state.contextualKeyword === keywords_1.ContextualKeyword._using &&
                    !(0, util_1.hasFollowingLineBreak)() &&
                    // Statements like `using[0]` and `using in foo` aren't actual using
                    // declarations.
                    (0, tokenizer_1.lookaheadType)() === types_1.TokenType.name) {
                    parseVarStatement(true);
                    return;
                }
                else if (startsAwaitUsing()) {
                    (0, util_1.expectContextual)(keywords_1.ContextualKeyword._await);
                    parseVarStatement(true);
                    return;
                }
            default:
                // Do nothing.
                break;
        }
        // If the statement does not start with a statement keyword or a
        // brace, it's an ExpressionStatement or LabeledStatement. We
        // simply start parsing an expression, and afterwards, if the
        // next token is a colon and the expression was a simple
        // Identifier node, we switch to interpreting it as a label.
        const initialTokensLength = base_1.state.tokens.length;
        (0, expression_1.parseExpression)();
        let simpleName = null;
        if (base_1.state.tokens.length === initialTokensLength + 1) {
            const token = base_1.state.tokens[base_1.state.tokens.length - 1];
            if (token.type === types_1.TokenType.name) {
                simpleName = token.contextualKeyword;
            }
        }
        if (simpleName == null) {
            (0, util_1.semicolon)();
            return;
        }
        if ((0, tokenizer_1.eat)(types_1.TokenType.colon)) {
            parseLabeledStatement();
        }
        else {
            // This was an identifier, so we might want to handle flow/typescript-specific cases.
            parseIdentifierStatement(simpleName);
        }
    }
    /**
     * Determine if we're positioned at an `await using` declaration.
     *
     * Note that this can happen either in place of a regular variable declaration
     * or in a loop body, and in both places, there are similar-looking cases where
     * we need to return false.
     *
     * Examples returning true:
     * await using foo = bar();
     * for (await using a of b) {}
     *
     * Examples returning false:
     * await using
     * await using + 1
     * await using instanceof T
     * for (await using;;) {}
     *
     * For now, we early return if we don't see `await`, then do a simple
     * backtracking-based lookahead for the `using` and identifier tokens. In the
     * future, this could be optimized with a character-based approach.
     */
    function startsAwaitUsing() {
        if (!(0, util_1.isContextual)(keywords_1.ContextualKeyword._await)) {
            return false;
        }
        const snapshot = base_1.state.snapshot();
        // await
        (0, tokenizer_1.next)();
        if (!(0, util_1.isContextual)(keywords_1.ContextualKeyword._using) || (0, util_1.hasPrecedingLineBreak)()) {
            base_1.state.restoreFromSnapshot(snapshot);
            return false;
        }
        // using
        (0, tokenizer_1.next)();
        if (!(0, tokenizer_1.match)(types_1.TokenType.name) || (0, util_1.hasPrecedingLineBreak)()) {
            base_1.state.restoreFromSnapshot(snapshot);
            return false;
        }
        base_1.state.restoreFromSnapshot(snapshot);
        return true;
    }
    function parseDecorators() {
        while ((0, tokenizer_1.match)(types_1.TokenType.at)) {
            parseDecorator();
        }
    }
    function parseDecorator() {
        (0, tokenizer_1.next)();
        if ((0, tokenizer_1.eat)(types_1.TokenType.parenL)) {
            (0, expression_1.parseExpression)();
            (0, util_1.expect)(types_1.TokenType.parenR);
        }
        else {
            (0, expression_1.parseIdentifier)();
            while ((0, tokenizer_1.eat)(types_1.TokenType.dot)) {
                (0, expression_1.parseIdentifier)();
            }
            parseMaybeDecoratorArguments();
        }
    }
    function parseMaybeDecoratorArguments() {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseMaybeDecoratorArguments)();
        }
        else {
            baseParseMaybeDecoratorArguments();
        }
    }
    function baseParseMaybeDecoratorArguments() {
        if ((0, tokenizer_1.eat)(types_1.TokenType.parenL)) {
            (0, expression_1.parseCallExpressionArguments)();
        }
    }
    function parseBreakContinueStatement() {
        (0, tokenizer_1.next)();
        if (!(0, util_1.isLineTerminator)()) {
            (0, expression_1.parseIdentifier)();
            (0, util_1.semicolon)();
        }
    }
    function parseDebuggerStatement() {
        (0, tokenizer_1.next)();
        (0, util_1.semicolon)();
    }
    function parseDoStatement() {
        (0, tokenizer_1.next)();
        parseStatement(false);
        (0, util_1.expect)(types_1.TokenType._while);
        (0, expression_1.parseParenExpression)();
        (0, tokenizer_1.eat)(types_1.TokenType.semi);
    }
    function parseForStatement() {
        base_1.state.scopeDepth++;
        const startTokenIndex = base_1.state.tokens.length;
        parseAmbiguousForStatement();
        const endTokenIndex = base_1.state.tokens.length;
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, false));
        base_1.state.scopeDepth--;
    }
    /**
     * Determine if this token is a `using` declaration (explicit resource
     * management) as part of a loop.
     * https://github.com/tc39/proposal-explicit-resource-management
     */
    function isUsingInLoop() {
        if (!(0, util_1.isContextual)(keywords_1.ContextualKeyword._using)) {
            return false;
        }
        // This must be `for (using of`, where `using` is the name of the loop
        // variable.
        if ((0, util_1.isLookaheadContextual)(keywords_1.ContextualKeyword._of)) {
            return false;
        }
        return true;
    }
    // Disambiguating between a `for` and a `for`/`in` or `for`/`of`
    // loop is non-trivial. Basically, we have to parse the init `var`
    // statement or expression, disallowing the `in` operator (see
    // the second parameter to `parseExpression`), and then check
    // whether the next token is `in` or `of`. When there is no init
    // part (semicolon immediately after the opening parenthesis), it
    // is a regular `for` loop.
    function parseAmbiguousForStatement() {
        (0, tokenizer_1.next)();
        let forAwait = false;
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._await)) {
            forAwait = true;
            (0, tokenizer_1.next)();
        }
        (0, util_1.expect)(types_1.TokenType.parenL);
        if ((0, tokenizer_1.match)(types_1.TokenType.semi)) {
            if (forAwait) {
                (0, util_1.unexpected)();
            }
            parseFor();
            return;
        }
        const isAwaitUsing = startsAwaitUsing();
        if (isAwaitUsing || (0, tokenizer_1.match)(types_1.TokenType._var) || (0, tokenizer_1.match)(types_1.TokenType._let) || (0, tokenizer_1.match)(types_1.TokenType._const) || isUsingInLoop()) {
            if (isAwaitUsing) {
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._await);
            }
            (0, tokenizer_1.next)();
            parseVar(true, base_1.state.type !== types_1.TokenType._var);
            if ((0, tokenizer_1.match)(types_1.TokenType._in) || (0, util_1.isContextual)(keywords_1.ContextualKeyword._of)) {
                parseForIn(forAwait);
                return;
            }
            parseFor();
            return;
        }
        (0, expression_1.parseExpression)(true);
        if ((0, tokenizer_1.match)(types_1.TokenType._in) || (0, util_1.isContextual)(keywords_1.ContextualKeyword._of)) {
            parseForIn(forAwait);
            return;
        }
        if (forAwait) {
            (0, util_1.unexpected)();
        }
        parseFor();
    }
    function parseFunctionStatement() {
        const functionStart = base_1.state.start;
        (0, tokenizer_1.next)();
        parseFunction(functionStart, true);
    }
    function parseIfStatement() {
        (0, tokenizer_1.next)();
        (0, expression_1.parseParenExpression)();
        parseStatement(false);
        if ((0, tokenizer_1.eat)(types_1.TokenType._else)) {
            parseStatement(false);
        }
    }
    function parseReturnStatement() {
        (0, tokenizer_1.next)();
        // In `return` (and `break`/`continue`), the keywords with
        // optional arguments, we eagerly look for a semicolon or the
        // possibility to insert one.
        if (!(0, util_1.isLineTerminator)()) {
            (0, expression_1.parseExpression)();
            (0, util_1.semicolon)();
        }
    }
    function parseSwitchStatement() {
        (0, tokenizer_1.next)();
        (0, expression_1.parseParenExpression)();
        base_1.state.scopeDepth++;
        const startTokenIndex = base_1.state.tokens.length;
        (0, util_1.expect)(types_1.TokenType.braceL);
        // Don't bother validation; just go through any sequence of cases, defaults, and statements.
        while (!(0, tokenizer_1.match)(types_1.TokenType.braceR) && !base_1.state.error) {
            if ((0, tokenizer_1.match)(types_1.TokenType._case) || (0, tokenizer_1.match)(types_1.TokenType._default)) {
                const isCase = (0, tokenizer_1.match)(types_1.TokenType._case);
                (0, tokenizer_1.next)();
                if (isCase) {
                    (0, expression_1.parseExpression)();
                }
                (0, util_1.expect)(types_1.TokenType.colon);
            }
            else {
                parseStatement(true);
            }
        }
        (0, tokenizer_1.next)(); // Closing brace
        const endTokenIndex = base_1.state.tokens.length;
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, false));
        base_1.state.scopeDepth--;
    }
    function parseThrowStatement() {
        (0, tokenizer_1.next)();
        (0, expression_1.parseExpression)();
        (0, util_1.semicolon)();
    }
    function parseCatchClauseParam() {
        (0, lval_1.parseBindingAtom)(true /* isBlockScope */);
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsTryParseTypeAnnotation)();
        }
    }
    function parseTryStatement() {
        (0, tokenizer_1.next)();
        parseBlock();
        if ((0, tokenizer_1.match)(types_1.TokenType._catch)) {
            (0, tokenizer_1.next)();
            let catchBindingStartTokenIndex = null;
            if ((0, tokenizer_1.match)(types_1.TokenType.parenL)) {
                base_1.state.scopeDepth++;
                catchBindingStartTokenIndex = base_1.state.tokens.length;
                (0, util_1.expect)(types_1.TokenType.parenL);
                parseCatchClauseParam();
                (0, util_1.expect)(types_1.TokenType.parenR);
            }
            parseBlock();
            if (catchBindingStartTokenIndex != null) {
                // We need a special scope for the catch binding which includes the binding itself and the
                // catch block.
                const endTokenIndex = base_1.state.tokens.length;
                base_1.state.scopes.push(new state_1.Scope(catchBindingStartTokenIndex, endTokenIndex, false));
                base_1.state.scopeDepth--;
            }
        }
        if ((0, tokenizer_1.eat)(types_1.TokenType._finally)) {
            parseBlock();
        }
    }
    function parseVarStatement(isBlockScope) {
        (0, tokenizer_1.next)();
        parseVar(false, isBlockScope);
        (0, util_1.semicolon)();
    }
    function parseWhileStatement() {
        (0, tokenizer_1.next)();
        (0, expression_1.parseParenExpression)();
        parseStatement(false);
    }
    function parseEmptyStatement() {
        (0, tokenizer_1.next)();
    }
    function parseLabeledStatement() {
        parseStatement(true);
    }
    /**
     * Parse a statement starting with an identifier of the given name. Subclasses match on the name
     * to handle statements like "declare".
     */
    function parseIdentifierStatement(contextualKeyword) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseIdentifierStatement)(contextualKeyword);
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseIdentifierStatement)(contextualKeyword);
        }
        else {
            (0, util_1.semicolon)();
        }
    }
    // Parse a semicolon-enclosed block of statements.
    function parseBlock(isFunctionScope = false, contextId = 0) {
        const startTokenIndex = base_1.state.tokens.length;
        base_1.state.scopeDepth++;
        (0, util_1.expect)(types_1.TokenType.braceL);
        if (contextId) {
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
        }
        parseBlockBody(types_1.TokenType.braceR);
        if (contextId) {
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
        }
        const endTokenIndex = base_1.state.tokens.length;
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, isFunctionScope));
        base_1.state.scopeDepth--;
    }
    function parseBlockBody(end) {
        while (!(0, tokenizer_1.eat)(end) && !base_1.state.error) {
            parseStatement(true);
        }
    }
    // Parse a regular `for` loop. The disambiguation code in
    // `parseStatement` will already have parsed the init statement or
    // expression.
    function parseFor() {
        (0, util_1.expect)(types_1.TokenType.semi);
        if (!(0, tokenizer_1.match)(types_1.TokenType.semi)) {
            (0, expression_1.parseExpression)();
        }
        (0, util_1.expect)(types_1.TokenType.semi);
        if (!(0, tokenizer_1.match)(types_1.TokenType.parenR)) {
            (0, expression_1.parseExpression)();
        }
        (0, util_1.expect)(types_1.TokenType.parenR);
        parseStatement(false);
    }
    // Parse a `for`/`in` and `for`/`of` loop, which are almost
    // same from parser's perspective.
    function parseForIn(forAwait) {
        if (forAwait) {
            (0, util_1.eatContextual)(keywords_1.ContextualKeyword._of);
        }
        else {
            (0, tokenizer_1.next)();
        }
        (0, expression_1.parseExpression)();
        (0, util_1.expect)(types_1.TokenType.parenR);
        parseStatement(false);
    }
    // Parse a list of variable declarations.
    function parseVar(isFor, isBlockScope) {
        while (true) {
            parseVarHead(isBlockScope);
            if ((0, tokenizer_1.eat)(types_1.TokenType.eq)) {
                const eqIndex = base_1.state.tokens.length - 1;
                (0, expression_1.parseMaybeAssign)(isFor);
                base_1.state.tokens[eqIndex].rhsEndIndex = base_1.state.tokens.length;
            }
            if (!(0, tokenizer_1.eat)(types_1.TokenType.comma)) {
                break;
            }
        }
    }
    function parseVarHead(isBlockScope) {
        (0, lval_1.parseBindingAtom)(isBlockScope);
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsAfterParseVarHead)();
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowAfterParseVarHead)();
        }
    }
    // Parse a function declaration or literal (depending on the
    // `isStatement` parameter).
    function parseFunction(functionStart, isStatement, optionalId = false) {
        if ((0, tokenizer_1.match)(types_1.TokenType.star)) {
            (0, tokenizer_1.next)();
        }
        if (isStatement && !optionalId && !(0, tokenizer_1.match)(types_1.TokenType.name) && !(0, tokenizer_1.match)(types_1.TokenType._yield)) {
            (0, util_1.unexpected)();
        }
        let nameScopeStartTokenIndex = null;
        if ((0, tokenizer_1.match)(types_1.TokenType.name)) {
            // Expression-style functions should limit their name's scope to the function body, so we make
            // a new function scope to enforce that.
            if (!isStatement) {
                nameScopeStartTokenIndex = base_1.state.tokens.length;
                base_1.state.scopeDepth++;
            }
            (0, lval_1.parseBindingIdentifier)(false);
        }
        const startTokenIndex = base_1.state.tokens.length;
        base_1.state.scopeDepth++;
        parseFunctionParams();
        (0, expression_1.parseFunctionBodyAndFinish)(functionStart);
        const endTokenIndex = base_1.state.tokens.length;
        // In addition to the block scope of the function body, we need a separate function-style scope
        // that includes the params.
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, true));
        base_1.state.scopeDepth--;
        if (nameScopeStartTokenIndex !== null) {
            base_1.state.scopes.push(new state_1.Scope(nameScopeStartTokenIndex, endTokenIndex, true));
            base_1.state.scopeDepth--;
        }
    }
    function parseFunctionParams(allowModifiers = false, funcContextId = 0) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsStartParseFunctionParams)();
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowStartParseFunctionParams)();
        }
        (0, util_1.expect)(types_1.TokenType.parenL);
        if (funcContextId) {
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = funcContextId;
        }
        (0, lval_1.parseBindingList)(types_1.TokenType.parenR, false /* isBlockScope */, false /* allowEmpty */, allowModifiers, funcContextId);
        if (funcContextId) {
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = funcContextId;
        }
    }
    // Parse a class declaration or literal (depending on the
    // `isStatement` parameter).
    function parseClass(isStatement, optionalId = false) {
        // Put a context ID on the class keyword, the open-brace, and the close-brace, so that later
        // code can easily navigate to meaningful points on the class.
        const contextId = (0, base_1.getNextContextId)();
        (0, tokenizer_1.next)();
        base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
        base_1.state.tokens[base_1.state.tokens.length - 1].isExpression = !isStatement;
        // Like with functions, we declare a special "name scope" from the start of the name to the end
        // of the class, but only with expression-style classes, to represent the fact that the name is
        // available to the body of the class but not an outer declaration.
        let nameScopeStartTokenIndex = null;
        if (!isStatement) {
            nameScopeStartTokenIndex = base_1.state.tokens.length;
            base_1.state.scopeDepth++;
        }
        parseClassId(isStatement, optionalId);
        parseClassSuper();
        const openBraceIndex = base_1.state.tokens.length;
        parseClassBody(contextId);
        if (base_1.state.error) {
            return;
        }
        base_1.state.tokens[openBraceIndex].contextId = contextId;
        base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
        if (nameScopeStartTokenIndex !== null) {
            const endTokenIndex = base_1.state.tokens.length;
            base_1.state.scopes.push(new state_1.Scope(nameScopeStartTokenIndex, endTokenIndex, false));
            base_1.state.scopeDepth--;
        }
    }
    function isClassProperty() {
        return (0, tokenizer_1.match)(types_1.TokenType.eq) || (0, tokenizer_1.match)(types_1.TokenType.semi) || (0, tokenizer_1.match)(types_1.TokenType.braceR) || (0, tokenizer_1.match)(types_1.TokenType.bang) || (0, tokenizer_1.match)(types_1.TokenType.colon);
    }
    function isClassMethod() {
        return (0, tokenizer_1.match)(types_1.TokenType.parenL) || (0, tokenizer_1.match)(types_1.TokenType.lessThan);
    }
    function parseClassBody(classContextId) {
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, tokenizer_1.eat)(types_1.TokenType.braceR) && !base_1.state.error) {
            if ((0, tokenizer_1.eat)(types_1.TokenType.semi)) {
                continue;
            }
            if ((0, tokenizer_1.match)(types_1.TokenType.at)) {
                parseDecorator();
                continue;
            }
            const memberStart = base_1.state.start;
            parseClassMember(memberStart, classContextId);
        }
    }
    function parseClassMember(memberStart, classContextId) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseModifiers)([
                keywords_1.ContextualKeyword._declare,
                keywords_1.ContextualKeyword._public,
                keywords_1.ContextualKeyword._protected,
                keywords_1.ContextualKeyword._private,
                keywords_1.ContextualKeyword._override,
            ]);
        }
        let isStatic = false;
        if ((0, tokenizer_1.match)(types_1.TokenType.name) && base_1.state.contextualKeyword === keywords_1.ContextualKeyword._static) {
            (0, expression_1.parseIdentifier)(); // eats 'static'
            if (isClassMethod()) {
                parseClassMethod(memberStart, /* isConstructor */ false);
                return;
            }
            else if (isClassProperty()) {
                parseClassProperty();
                return;
            }
            // otherwise something static
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._static;
            isStatic = true;
            if ((0, tokenizer_1.match)(types_1.TokenType.braceL)) {
                // This is a static block. Mark the word "static" with the class context ID for class element
                // detection and parse as a regular block.
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = classContextId;
                parseBlock();
                return;
            }
        }
        parseClassMemberWithIsStatic(memberStart, isStatic, classContextId);
    }
    function parseClassMemberWithIsStatic(memberStart, isStatic, classContextId) {
        if (base_1.isTypeScriptEnabled) {
            if ((0, typescript_1.tsTryParseClassMemberWithIsStatic)(isStatic)) {
                return;
            }
        }
        if ((0, tokenizer_1.eat)(types_1.TokenType.star)) {
            // a generator
            parseClassPropertyName(classContextId);
            parseClassMethod(memberStart, /* isConstructor */ false);
            return;
        }
        // Get the identifier name so we can tell if it's actually a keyword like "async", "get", or
        // "set".
        parseClassPropertyName(classContextId);
        let isConstructor = false;
        const token = base_1.state.tokens[base_1.state.tokens.length - 1];
        // We allow "constructor" as either an identifier or a string.
        if (token.contextualKeyword === keywords_1.ContextualKeyword._constructor) {
            isConstructor = true;
        }
        parsePostMemberNameModifiers();
        if (isClassMethod()) {
            parseClassMethod(memberStart, isConstructor);
        }
        else if (isClassProperty()) {
            parseClassProperty();
        }
        else if (token.contextualKeyword === keywords_1.ContextualKeyword._async && !(0, util_1.isLineTerminator)()) {
            base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._async;
            // an async method
            const isGenerator = (0, tokenizer_1.match)(types_1.TokenType.star);
            if (isGenerator) {
                (0, tokenizer_1.next)();
            }
            // The so-called parsed name would have been "async": get the real name.
            parseClassPropertyName(classContextId);
            parsePostMemberNameModifiers();
            parseClassMethod(memberStart, false /* isConstructor */);
        }
        else if ((token.contextualKeyword === keywords_1.ContextualKeyword._get ||
            token.contextualKeyword === keywords_1.ContextualKeyword._set) &&
            !((0, util_1.isLineTerminator)() && (0, tokenizer_1.match)(types_1.TokenType.star))) {
            if (token.contextualKeyword === keywords_1.ContextualKeyword._get) {
                base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._get;
            }
            else {
                base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._set;
            }
            // `get\n*` is an uninitialized property named 'get' followed by a generator.
            // a getter or setter
            // The so-called parsed name would have been "get/set": get the real name.
            parseClassPropertyName(classContextId);
            parseClassMethod(memberStart, /* isConstructor */ false);
        }
        else if (token.contextualKeyword === keywords_1.ContextualKeyword._accessor && !(0, util_1.isLineTerminator)()) {
            parseClassPropertyName(classContextId);
            parseClassProperty();
        }
        else if ((0, util_1.isLineTerminator)()) {
            // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
            parseClassProperty();
        }
        else {
            (0, util_1.unexpected)();
        }
    }
    function parseClassMethod(functionStart, isConstructor) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsTryParseTypeParameters)();
        }
        else if (base_1.isFlowEnabled) {
            if ((0, tokenizer_1.match)(types_1.TokenType.lessThan)) {
                (0, flow_1.flowParseTypeParameterDeclaration)();
            }
        }
        (0, expression_1.parseMethod)(functionStart, isConstructor);
    }
    // Return the name of the class property, if it is a simple identifier.
    function parseClassPropertyName(classContextId) {
        (0, expression_1.parsePropertyName)(classContextId);
    }
    function parsePostMemberNameModifiers() {
        if (base_1.isTypeScriptEnabled) {
            const oldIsType = (0, tokenizer_1.pushTypeContext)(0);
            (0, tokenizer_1.eat)(types_1.TokenType.question);
            (0, tokenizer_1.popTypeContext)(oldIsType);
        }
    }
    function parseClassProperty() {
        if (base_1.isTypeScriptEnabled) {
            (0, tokenizer_1.eatTypeToken)(types_1.TokenType.bang);
            (0, typescript_1.tsTryParseTypeAnnotation)();
        }
        else if (base_1.isFlowEnabled) {
            if ((0, tokenizer_1.match)(types_1.TokenType.colon)) {
                (0, flow_1.flowParseTypeAnnotation)();
            }
        }
        if ((0, tokenizer_1.match)(types_1.TokenType.eq)) {
            const equalsTokenIndex = base_1.state.tokens.length;
            (0, tokenizer_1.next)();
            (0, expression_1.parseMaybeAssign)();
            base_1.state.tokens[equalsTokenIndex].rhsEndIndex = base_1.state.tokens.length;
        }
        (0, util_1.semicolon)();
    }
    function parseClassId(isStatement, optionalId = false) {
        if (base_1.isTypeScriptEnabled &&
            (!isStatement || optionalId) &&
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._implements)) {
            return;
        }
        if ((0, tokenizer_1.match)(types_1.TokenType.name)) {
            (0, lval_1.parseBindingIdentifier)(true);
        }
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsTryParseTypeParameters)();
        }
        else if (base_1.isFlowEnabled) {
            if ((0, tokenizer_1.match)(types_1.TokenType.lessThan)) {
                (0, flow_1.flowParseTypeParameterDeclaration)();
            }
        }
    }
    // Returns true if there was a superclass.
    function parseClassSuper() {
        let hasSuper = false;
        if ((0, tokenizer_1.eat)(types_1.TokenType._extends)) {
            (0, expression_1.parseExprSubscripts)();
            hasSuper = true;
        }
        else {
            hasSuper = false;
        }
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsAfterParseClassSuper)(hasSuper);
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowAfterParseClassSuper)(hasSuper);
        }
    }
    // Parses module export declaration.
    function parseExport() {
        const exportIndex = base_1.state.tokens.length - 1;
        if (base_1.isTypeScriptEnabled) {
            if ((0, typescript_1.tsTryParseExport)()) {
                return;
            }
        }
        // export * from '...'
        if (shouldParseExportStar()) {
            parseExportStar();
        }
        else if (isExportDefaultSpecifier()) {
            // export default from
            (0, expression_1.parseIdentifier)();
            if ((0, tokenizer_1.match)(types_1.TokenType.comma) && (0, tokenizer_1.lookaheadType)() === types_1.TokenType.star) {
                (0, util_1.expect)(types_1.TokenType.comma);
                (0, util_1.expect)(types_1.TokenType.star);
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._as);
                (0, expression_1.parseIdentifier)();
            }
            else {
                parseExportSpecifiersMaybe();
            }
            parseExportFrom();
        }
        else if ((0, tokenizer_1.eat)(types_1.TokenType._default)) {
            // export default ...
            parseExportDefaultExpression();
        }
        else if (shouldParseExportDeclaration()) {
            parseExportDeclaration();
        }
        else {
            // export { x, y as z } [from '...']
            parseExportSpecifiers();
            parseExportFrom();
        }
        base_1.state.tokens[exportIndex].rhsEndIndex = base_1.state.tokens.length;
    }
    function parseExportDefaultExpression() {
        if (base_1.isTypeScriptEnabled) {
            if ((0, typescript_1.tsTryParseExportDefaultExpression)()) {
                return;
            }
        }
        if (base_1.isFlowEnabled) {
            if ((0, flow_1.flowTryParseExportDefaultExpression)()) {
                return;
            }
        }
        const functionStart = base_1.state.start;
        if ((0, tokenizer_1.eat)(types_1.TokenType._function)) {
            parseFunction(functionStart, true, true);
        }
        else if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._async) && (0, tokenizer_1.lookaheadType)() === types_1.TokenType._function) {
            // async function declaration
            (0, util_1.eatContextual)(keywords_1.ContextualKeyword._async);
            (0, tokenizer_1.eat)(types_1.TokenType._function);
            parseFunction(functionStart, true, true);
        }
        else if ((0, tokenizer_1.match)(types_1.TokenType._class)) {
            parseClass(true, true);
        }
        else if ((0, tokenizer_1.match)(types_1.TokenType.at)) {
            parseDecorators();
            parseClass(true, true);
        }
        else {
            (0, expression_1.parseMaybeAssign)();
            (0, util_1.semicolon)();
        }
    }
    function parseExportDeclaration() {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseExportDeclaration)();
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseExportDeclaration)();
        }
        else {
            parseStatement(true);
        }
    }
    function isExportDefaultSpecifier() {
        if (base_1.isTypeScriptEnabled && (0, typescript_1.tsIsDeclarationStart)()) {
            return false;
        }
        else if (base_1.isFlowEnabled && (0, flow_1.flowShouldDisallowExportDefaultSpecifier)()) {
            return false;
        }
        if ((0, tokenizer_1.match)(types_1.TokenType.name)) {
            return base_1.state.contextualKeyword !== keywords_1.ContextualKeyword._async;
        }
        if (!(0, tokenizer_1.match)(types_1.TokenType._default)) {
            return false;
        }
        const _next = (0, tokenizer_1.nextTokenStart)();
        const lookahead = (0, tokenizer_1.lookaheadTypeAndKeyword)();
        const hasFrom = lookahead.type === types_1.TokenType.name && lookahead.contextualKeyword === keywords_1.ContextualKeyword._from;
        if (lookahead.type === types_1.TokenType.comma) {
            return true;
        }
        // lookahead again when `export default from` is seen
        if (hasFrom) {
            const nextAfterFrom = base_1.input.charCodeAt((0, tokenizer_1.nextTokenStartSince)(_next + 4));
            return nextAfterFrom === charcodes_1.charCodes.quotationMark || nextAfterFrom === charcodes_1.charCodes.apostrophe;
        }
        return false;
    }
    function parseExportSpecifiersMaybe() {
        if ((0, tokenizer_1.eat)(types_1.TokenType.comma)) {
            parseExportSpecifiers();
        }
    }
    function parseExportFrom() {
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._from)) {
            (0, expression_1.parseExprAtom)();
            maybeParseImportAttributes();
        }
        (0, util_1.semicolon)();
    }
    function shouldParseExportStar() {
        if (base_1.isFlowEnabled) {
            return (0, flow_1.flowShouldParseExportStar)();
        }
        else {
            return (0, tokenizer_1.match)(types_1.TokenType.star);
        }
    }
    function parseExportStar() {
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseExportStar)();
        }
        else {
            baseParseExportStar();
        }
    }
    function baseParseExportStar() {
        (0, util_1.expect)(types_1.TokenType.star);
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._as)) {
            parseExportNamespace();
        }
        else {
            parseExportFrom();
        }
    }
    function parseExportNamespace() {
        (0, tokenizer_1.next)();
        base_1.state.tokens[base_1.state.tokens.length - 1].type = types_1.TokenType._as;
        (0, expression_1.parseIdentifier)();
        parseExportSpecifiersMaybe();
        parseExportFrom();
    }
    function shouldParseExportDeclaration() {
        return ((base_1.isTypeScriptEnabled && (0, typescript_1.tsIsDeclarationStart)()) ||
            (base_1.isFlowEnabled && (0, flow_1.flowShouldParseExportDeclaration)()) ||
            base_1.state.type === types_1.TokenType._var ||
            base_1.state.type === types_1.TokenType._const ||
            base_1.state.type === types_1.TokenType._let ||
            base_1.state.type === types_1.TokenType._function ||
            base_1.state.type === types_1.TokenType._class ||
            (0, util_1.isContextual)(keywords_1.ContextualKeyword._async) ||
            (0, tokenizer_1.match)(types_1.TokenType.at));
    }
    // Parses a comma-separated list of module exports.
    function parseExportSpecifiers() {
        let first = true;
        // export { x, y as z } [from '...']
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, tokenizer_1.eat)(types_1.TokenType.braceR) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_1.TokenType.comma);
                if ((0, tokenizer_1.eat)(types_1.TokenType.braceR)) {
                    break;
                }
            }
            parseExportSpecifier();
        }
    }
    function parseExportSpecifier() {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseExportSpecifier)();
            return;
        }
        (0, expression_1.parseIdentifier)();
        base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = tokenizer_1.IdentifierRole.ExportAccess;
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._as)) {
            (0, expression_1.parseIdentifier)();
        }
    }
    /**
     * Starting at the `module` token in an import, determine if it was truly an
     * import reflection token or just looks like one.
     *
     * Returns true for:
     * import module foo from "foo";
     * import module from from "foo";
     *
     * Returns false for:
     * import module from "foo";
     * import module, {bar} from "foo";
     */
    function isImportReflection() {
        const snapshot = base_1.state.snapshot();
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._module);
        if ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._from)) {
            if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._from)) {
                base_1.state.restoreFromSnapshot(snapshot);
                return true;
            }
            else {
                base_1.state.restoreFromSnapshot(snapshot);
                return false;
            }
        }
        else if ((0, tokenizer_1.match)(types_1.TokenType.comma)) {
            base_1.state.restoreFromSnapshot(snapshot);
            return false;
        }
        else {
            base_1.state.restoreFromSnapshot(snapshot);
            return true;
        }
    }
    /**
     * Eat the "module" token from the import reflection proposal.
     * https://github.com/tc39/proposal-import-reflection
     */
    function parseMaybeImportReflection() {
        // isImportReflection does snapshot/restore, so only run it if we see the word
        // "module".
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._module) && isImportReflection()) {
            (0, tokenizer_1.next)();
        }
    }
    // Parses import declaration.
    function parseImport() {
        if (base_1.isTypeScriptEnabled && (0, tokenizer_1.match)(types_1.TokenType.name) && (0, tokenizer_1.lookaheadType)() === types_1.TokenType.eq) {
            (0, typescript_1.tsParseImportEqualsDeclaration)();
            return;
        }
        if (base_1.isTypeScriptEnabled && (0, util_1.isContextual)(keywords_1.ContextualKeyword._type)) {
            const lookahead = (0, tokenizer_1.lookaheadTypeAndKeyword)();
            if (lookahead.type === types_1.TokenType.name && lookahead.contextualKeyword !== keywords_1.ContextualKeyword._from) {
                // One of these `import type` cases:
                // import type T = require('T');
                // import type A from 'A';
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._type);
                if ((0, tokenizer_1.lookaheadType)() === types_1.TokenType.eq) {
                    (0, typescript_1.tsParseImportEqualsDeclaration)();
                    return;
                }
                // If this is an `import type...from` statement, then we already ate the
                // type token, so proceed to the regular import parser.
            }
            else if (lookahead.type === types_1.TokenType.star || lookahead.type === types_1.TokenType.braceL) {
                // One of these `import type` cases, in which case we can eat the type token
                // and proceed as normal:
                // import type * as A from 'A';
                // import type {a} from 'A';
                (0, util_1.expectContextual)(keywords_1.ContextualKeyword._type);
            }
            // Otherwise, we are importing the name "type".
        }
        // import '...'
        if ((0, tokenizer_1.match)(types_1.TokenType.string)) {
            (0, expression_1.parseExprAtom)();
        }
        else {
            parseMaybeImportReflection();
            parseImportSpecifiers();
            (0, util_1.expectContextual)(keywords_1.ContextualKeyword._from);
            (0, expression_1.parseExprAtom)();
        }
        maybeParseImportAttributes();
        (0, util_1.semicolon)();
    }
    // eslint-disable-next-line no-unused-vars
    function shouldParseDefaultImport() {
        return (0, tokenizer_1.match)(types_1.TokenType.name);
    }
    function parseImportSpecifierLocal() {
        (0, lval_1.parseImportedIdentifier)();
    }
    // Parses a comma-separated list of module imports.
    function parseImportSpecifiers() {
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowStartParseImportSpecifiers)();
        }
        let first = true;
        if (shouldParseDefaultImport()) {
            // import defaultObj, { x, y as z } from '...'
            parseImportSpecifierLocal();
            if (!(0, tokenizer_1.eat)(types_1.TokenType.comma))
                return;
        }
        if ((0, tokenizer_1.match)(types_1.TokenType.star)) {
            (0, tokenizer_1.next)();
            (0, util_1.expectContextual)(keywords_1.ContextualKeyword._as);
            parseImportSpecifierLocal();
            return;
        }
        (0, util_1.expect)(types_1.TokenType.braceL);
        while (!(0, tokenizer_1.eat)(types_1.TokenType.braceR) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                // Detect an attempt to deep destructure
                if ((0, tokenizer_1.eat)(types_1.TokenType.colon)) {
                    (0, util_1.unexpected)("ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
                }
                (0, util_1.expect)(types_1.TokenType.comma);
                if ((0, tokenizer_1.eat)(types_1.TokenType.braceR)) {
                    break;
                }
            }
            parseImportSpecifier();
        }
    }
    function parseImportSpecifier() {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseImportSpecifier)();
            return;
        }
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseImportSpecifier)();
            return;
        }
        (0, lval_1.parseImportedIdentifier)();
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._as)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = tokenizer_1.IdentifierRole.ImportAccess;
            (0, tokenizer_1.next)();
            (0, lval_1.parseImportedIdentifier)();
        }
    }
    /**
     * Parse import attributes like `with {type: "json"}`, or the legacy form
     * `assert {type: "json"}`.
     *
     * Import attributes technically have their own syntax, but are always parseable
     * as a plain JS object, so just do that for simplicity.
     */
    function maybeParseImportAttributes() {
        if ((0, tokenizer_1.match)(types_1.TokenType._with) || ((0, util_1.isContextual)(keywords_1.ContextualKeyword._assert) && !(0, util_1.hasPrecedingLineBreak)())) {
            (0, tokenizer_1.next)();
            (0, expression_1.parseObj)(false, false);
        }
    }
}
